import { Text } from 'react-native'
import { styled } from '~/core/styled'

export const Label = styled(Text, theme => {
  return {
    base: {
      fontFamily: theme.fontFamily.regular,
      fontWeight: theme.fontWeightRegular,
      paddingHorizontal: theme.paddingInsetOnepulse,
      paddingVertical: theme.paddingInsetHalfpulse,
      fontSize: theme.fontSizeThreeandhalfpulse,
      color: theme.colorTextNeutralDefault,
      maxHeight: theme.sizingExtrasmall,
    },
    variants: {
      size: {
        md: {
          maxHeight: theme.sizingExtrasmall,
          fontSize: theme.fontSizeThreepulse,
        },
        ml: {
          maxHeight: theme.sizingMediumlarge,
        },
        lg: {
          maxHeight: theme.sizingLarge,
        },
        xl: {
          maxHeight: theme.sizingExtralarge,
        },
      },
      disabled: {
        true: {
          color: theme.colorTextNeutralDisabled,
        },
      },
      readonly: {
        true: {
          color: theme.colorTextNeutralReadonly,
        },
      },
    },
    compoundVariants: [
      {
        variants: {
          disabled: true,
          readonly: true,
        },
        css: {
          color: theme.colorTextNeutralDisabled,
        },
      },
    ],
  }
})
